import React from 'react'
import { Icon } from '@alto-avios/alto-ui'
import { SearchCarHireLocationDetailsProps } from './SearchCarHireLocationDetails.types'
import styles from './SearchCarHireLocationDetails.module.scss'

export function SearchCarHireLocationDetails({
  locationType,
  label,
  toggleVisibility,
}: SearchCarHireLocationDetailsProps) {
  return (
    <div className={styles.helperMessageText}>
      <button
        className={styles.helperMessageButton}
        onClick={() => toggleVisibility(locationType)}
        type="button"
      >
        <Icon iconName="circle-info" iconSize="1x" />
        {label}
      </button>
    </div>
  )
}
